<template>
	<div id="app">
		<div v-show="showBoard == 1 || isPc">
			<NavPc v-if="isPc && !is3d"></NavPc>
			<router-view />
			<NavBottomPc v-if="isPc && !is3d" v-show="isShowFooter"></NavBottomPc>
			<TabBar v-if="!isPc && !is3d" v-show="isShowFooter" />
		</div>
		<div v-if="showBoard == 0 && !isPc">
			<Board />
		</div>
		<!-- <div v-else> -->
		<!-- <NavM></NavM> -->
		<!-- <router-view />
    </div> -->

    <!-- 🎯 公告弹框 -->
    <NoticeDialog
      :visible="noticeVisible"
      :title="noticeTitle"
      :content="noticeContent"
      :isRichText="noticeIsRichText"
      @close="closeNotice"
    />
	</div>
</template>
<script>
import request from "@/utils/request";
import TabBar from "@/components/TabBar.vue";
import NavPc from "@/components/nav_pc.vue";
import NavM from "@/components/nav_m.vue";
import NavBottomPc from "@/components/nav_bottom_pc.vue";
import {
	mapState
} from "vuex";
import store from "./store";
import Board from "./components/Board.vue";
import NoticeDialog from "./components/NoticeDialog.vue";
import { getActiveAnnouncements } from "@/api/market";
export default {
	data() {
		return {
			windowWidth: document.body.clientWidth,
			// 不显示底部白名单
			showBoard: 1,
			// 🎯 公告弹框相关
			noticeVisible: false,
			noticeTitle: '',
			noticeContent: '',
			noticeIsRichText: false,
			noticeShown: false
		};
	},
	components: {
		NavPc,
		NavM,
		NavBottomPc,
		TabBar,
		Board,
		NoticeDialog
	},
	mounted() {
		store.commit("SetInnerWidth", document.body.clientWidth);
		store.commit("SET_IS_PC", this.isMobileDevice());
		window.onresize = () => {
			return (() => {
				this.windowWidth = document.documentElement.clientWidth; // 宽
				store.commit("SetInnerWidth", this.windowWidth);
				store.commit("SET_IS_PC", this.isMobileDevice());
			})();
		};
		// 在页面加载时和窗口大小变化时调用设置字体大小的函数
		window.addEventListener('DOMContentLoaded', this.setRootFontSize);
		window.addEventListener('resize', this.setRootFontSize);
		// 设置默认语言
		let lang = localStorage.getItem("lang") || this.$store.state.currentLanguage;
		this.$store.commit("SET_LANG", lang);
		this.$store.dispatch("listContents", lang == 'zh' ? 1 : 2).then((res) => {
			console.log(res, "language");
		});
		// 设置是否虚拟账户
		console.log(localStorage.getItem("virtualStatus"));
		let isVirtual = localStorage.getItem("virtualStatus") || 1;
		this.$store.commit("changeVirtual", isVirtual);
		// 全局市场数据WebSocket
		try {
			console.log('🌐 [全局WebSocket] 开始连接市场数据WebSocket');
			this.$store.dispatch("GET_WS_MARKET").then((res) => {
				console.log('🌐 [全局WebSocket]', res, "连接成功");
			}).catch((err) => {
				console.log('🌐 [全局WebSocket] 连接失败:', err);
			});
		} catch (error) {
			console.log('🌐 [全局WebSocket] 异常:', error);
		}
		// 🎯 延迟检查公告，解决Trust钱包等环境的时序问题
		this.initNoticeCheck();
		// 🎯 获取公告推送（无需登录，基于语言和时间范围）
		this.fetchAnnouncement();


		// 判断当前是手机还是pc
	},
	watch: {
		// 监听页面宽度
		windowWidth(val) {
			console.log(val, "width");
			// store.commit('SetInnerWidth', val)
		},

		// 🎯 监听路由变化（移除公告检查，避免切换页面时重复显示）
		'$route'(to, from) {
			// 路由切换时不再检查公告，只在初次登录或刷新时检查
		},

		// 🎯 监听登录状态变化，登出时重置公告显示标记
		'$store.state.isLogin'(newVal, oldVal) {
			if (!newVal && oldVal) {
				// 用户登出时重置公告显示标记
				this.noticeShown = false;
				console.log('🎯 [用户公告] 用户登出，重置公告显示标记');
			}
		},
	},
	computed: {
		...mapState([
			"footerWhiteList",
			"isPc",
			"lginWhiteList",
			// "showBoard"
		]),
		currentRouteName() {
			return this.$route.name;
		},
		is3d() {
			return this.lginWhiteList.indexOf(this.currentRouteName) > -1;
		},
		isShowFooter() {
			return this.footerWhiteList.indexOf(this.currentRouteName) == -1;
		},
	},
	methods: {


		isMobileDevice() {
			var userAgent = navigator.userAgent;
			return !(/Android|iPhone|iPad|iPod/i.test(userAgent));
		},

		setRootFontSize() {
			console.log(111);
			let baseWidth = 1920;
			if (window.innerWidth > 1000) {
				baseWidth = 1920;
			} else {
				baseWidth = 750;
			}
			const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			let scale = 1;
			if (baseWidth == 750) {
				scale = (screenWidth / baseWidth) + .37;
			} else {
				// scale=(screenWidth/baseWidth) + .2;
				scale = (screenWidth / baseWidth) + 1;
			}
			console.log(scale, 'scale');
			const maxRemSize = 100;
			const rootFontSize = Math.min(maxRemSize, 100 * scale);
			console.log(rootFontSize, 'rootFontSize');
			document.documentElement.style.fontSize = rootFontSize + 'px';
		},

		// 🎯 初始化公告检查（解决Trust钱包等环境的时序问题）
		initNoticeCheck() {
			// 🎯 检测是否在Trust钱包环境
			const isTrustWallet = this.isTrustWallet();
			console.log('🎯 [用户公告] 开始初始化公告检查', {
				isTrustWallet,
				userAgent: navigator.userAgent
			});

			// 立即检查一次
			this.performNoticeCheck();

			// 🎯 为Trust钱包等环境添加延迟检查
			const delays = isTrustWallet ? [500, 1500, 3000] : [500, 1500];

			delays.forEach((delay, index) => {
				setTimeout(() => {
					console.log(`🎯 [用户公告] 延迟检查公告（${delay}ms）`);
					this.performNoticeCheck();
				}, delay);
			});
		},

		// 🎯 检测是否在Trust钱包环境
		isTrustWallet() {
			const userAgent = navigator.userAgent || '';
			return userAgent.includes('Trust') ||
				   userAgent.includes('TrustWallet') ||
				   window.trustwallet !== undefined ||
				   window.ethereum?.isTrust === true;
		},

		// 🎯 执行公告检查
		performNoticeCheck() {
			// 如果已经显示过公告，跳过
			if (this.noticeShown) {
				console.log('🎯 [用户公告] 公告已显示过，跳过延迟检查');
				return;
			}

			const isLogin = localStorage.getItem("isLogin") === 'true';
			const hasToken = localStorage.getItem("token");

			console.log('🎯 [用户公告] 执行公告检查', {
				isLogin,
				hasToken: !!hasToken,
				storeUserInfo: !!this.$store.state.userInfo
			});

			if (isLogin && hasToken) {
				// 主要检查：通过API获取用户信息
				this.$store.dispatch("GET_USER_INFO").then((res) => {
					console.log('🎯 [用户公告] API获取用户信息成功:', res);
					const userInfo = res.result || res;
					this.checkUserNotice(userInfo);
				}).catch((err) => {
					console.error("🎯 [用户公告] 获取用户信息失败:", err);
					// 如果API失败，尝试从store获取
					this.checkUserInfoFromStore();
				});
			} else {
				// 备用检查：从store中获取用户信息
				this.checkUserInfoFromStore();
			}
		},

		// 🎯 从store检查用户信息
		checkUserInfoFromStore() {
			if (this.$store.state.userInfo && Object.keys(this.$store.state.userInfo).length > 0) {
				console.log('🎯 [用户公告] 从store中检查公告');
				this.checkUserNotice(this.$store.state.userInfo);
			} else {
				console.log('🎯 [用户公告] store中无用户信息');
			}
		},

		// 🎯 检查用户公告
		checkUserNotice(userInfo) {
			console.log('🎯 [用户公告] 开始检查公告', {
				noticeShown: this.noticeShown,
				userInfo: userInfo,
				hasNoticeTitle: !!(userInfo && userInfo.noticeTitle),
				hasNoticeContent: !!(userInfo && userInfo.noticeContent)
			});

			// 如果公告已经显示过，不再重复显示
			if (this.noticeShown) {
				console.log('🎯 [用户公告] 公告已显示过，跳过');
				return;
			}

			if (userInfo && userInfo.noticeTitle && userInfo.noticeContent) {
				this.noticeTitle = userInfo.noticeTitle;
				this.noticeContent = userInfo.noticeContent;
				this.noticeVisible = true;
				this.noticeShown = true; // 🎯 标记公告已显示
				console.log('🎯 [用户公告] 显示公告:', userInfo.noticeTitle);
			} else {
				console.log('🎯 [用户公告] 无公告需要显示');
			}
		},

		// 🎯 关闭公告弹框
		closeNotice() {
			this.noticeVisible = false;
			this.noticeTitle = '';
			this.noticeContent = '';
			this.noticeIsRichText = false;
			console.log('🎯 [用户公告] 公告已关闭');
		},

		// 🎯 获取公告推送（基于语言和时间范围，不需要登录）
		fetchAnnouncement() {
			const lang = this.$store.state.currentLanguage || 'en';
			console.log('🎯 [公告推送] 获取公告, 语言:', lang);
			getActiveAnnouncements(lang).then(res => {
				if (res && res.code === 200 && res.result && res.result.length > 0) {
					const announcement = res.result[0];
					// 如果用户公告已显示，不覆盖
					if (this.noticeShown) {
						console.log('🎯 [公告推送] 用户公告已显示，跳过系统公告');
						return;
					}
					this.noticeTitle = announcement.title;
					this.noticeContent = announcement.content;
					this.noticeIsRichText = true;
					this.noticeVisible = true;
					this.noticeShown = true;
					console.log('🎯 [公告推送] 显示公告:', announcement.title);
				} else {
					console.log('🎯 [公告推送] 无有效公告');
				}
			}).catch(err => {
				console.error('🎯 [公告推送] 获取公告失败:', err);
			});
		}
	},
};
</script>
<style>
@import "reset.css";
@import "styles/ios-safe-area.css";

/* @media screen and (min-width: 1000px) {
  #app {
    width: 1440px;
    margin: 0 auto;
  }
} */
@font-face {
	font-family: 'Mabry Pro';
	src: url('./assets/fonts/mabry-regular-pro.ttf');
	font-weight: normal;
	font-style: normal;
	font-display: swap;
}

body {
	font-size: 0.16rem;
}

img,
video {
	max-width: 100%;
	height: auto;
}

.button {
	cursor: pointer;
	padding: 0 .36rem;
	height: 100%;
	border-radius: .2rem;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 700;
	font-size: .2rem;
	color: #000;
	-webkit-tap-highlight-color: transparent
}

.button .icon {
	margin-right: .12rem;
	width: .24rem;
	height: .24rem
}

#app {
	margin: 0 auto;
	width: 100%;
	max-width: 14.4rem;
	font-family: Mabry Pro;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	font-size: .16rem;
	padding-bottom: .5rem !important;

	/* 🎯 苹果设备安全区域适配 */
	padding-top: constant(safe-area-inset-top); /* iOS 11.0 */
	padding-top: env(safe-area-inset-top); /* iOS 11.2+ */
	padding-bottom: constant(safe-area-inset-bottom); /* iOS 11.0 */
	padding-bottom: env(safe-area-inset-bottom); /* iOS 11.2+ */
	padding-left: constant(safe-area-inset-left); /* iOS 11.0 */
	padding-left: env(safe-area-inset-left); /* iOS 11.2+ */
	padding-right: constant(safe-area-inset-right); /* iOS 11.0 */
	padding-right: env(safe-area-inset-right); /* iOS 11.2+ */

	/* 确保背景色填充整个安全区域 */
	background-color: #ffffff;
	min-height: 100vh;
	min-height: -webkit-fill-available;
}

.input_fields .el-input .el-input__wrapper {
	box-shadow: none;
	background: none;
}

.button.round {
	border-radius: .32rem
}

.button.normal {
	background: #e8e8e8
}

.button.yellow {
	background: linear-gradient(180deg, #ffdc61, #ffbc49)
}

.button.black {
	background: #000;
	color: #fff
}

.button.line {
	background: #fff;
	border: .02rem solid #000;
	box-sizing: border-box
}

.button.disabled {
	background: #dfdfdf;
	color: #8a8a8a
}

/* 🎯 完全移除按钮点击时的视觉变化 按钮样式问题  浅蓝色 阴影 */
.button:active,
button:active,
.tab:active,
.cur:active,
[role="button"]:active,
div[onclick]:active,
.btn:active,
.btn2:active,
.buttons:active,
span[onclick]:active {
	outline: none !important;
	box-shadow: none !important;
	border-radius: inherit !important;
	background: inherit !important;
	transform: none !important;
	transition: none !important;
	-webkit-tap-highlight-color: transparent !important;
	-webkit-touch-callout: none !important;
	-webkit-user-select: none !important;
	-khtml-user-select: none !important;
	-moz-user-select: none !important;
	-ms-user-select: none !important;
	user-select: none !important;
}

</style>